import { ProfilePictureLight } from '@/components/profile-picture/profile-picture.light';
import { formatPhone } from '@/lib';
import { groupServiceAccounts } from '@/routes/(services)/-model/group-service-accounts';
import { Loader } from '@nosinovacao/fe-icons';
import { Button, If, ImageProfile, mage, useI18n } from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavbarContext } from '../../context/navbar';
import { useServicesContext } from './context';

export function ServicesNavSheetSuccessContent() {
  const { t } = useI18n();
  const { flowData } = useServicesContext();
  const { setActiveSection } = useNavbarContext();
  const { services } = flowData;
  const client = useQueryClient();
  const [loading, setLoading] = useState(false);
  function handleClick() {
    setLoading(true);
    client.invalidateQueries().finally(() => {
      setLoading(false);
      setActiveSection('main');
    });
  }
  if (!services) return <></>;
  const name = services.Holder.PrimaryUserDisplayName;
  const image = mage.getImage(services.Holder.PictureUri, ImageProfile.App);
  const email = services.Holder.UsernameAliases.find((alias) => alias.Type === 'Email')?.Username;
  const phone = services.Holder.UsernameAliases.find((alias) => alias.Type === 'Mobile')?.Username;
  const contact = email ? email : phone ? formatPhone(phone ?? '') : undefined;
  const servicesList = groupServiceAccounts(services.Holder.ServiceAccounts);
  return (
    <div className="flex size-full flex-col gap-6 overflow-y-auto max-tablet:pb-8">
      <If condition={services.Type === 'Primary'}>
        <div className="grid gap-2">
          <span className="font-light text-nos-neutral-900 font-text-p1">
            {t('Services.AddServices.Success.AccountHolder')}
          </span>
          <div className="grid grid-cols-[auto_1fr] items-center gap-x-4 gap-y-1 rounded-lg border border-nos-neutral-200 bg-nos-neutral-0 p-4">
            <ProfilePictureLight name={name} size={40} src={image} className="row-span-2" />
            <span className="font-bold text-nos-neutral-900 font-text-p2">{name}</span>
            <span className="text-nos-neutral-900 font-text-p2">{contact ?? '-'}</span>
          </div>
        </div>
        <div className="grid gap-2">
          <span className="font-light text-nos-neutral-900 font-text-p1">
            {t('Services.AddServices.Success.Services')}
          </span>
          <div className="grid gap-1">
            {servicesList.map((service) => (
              <div
                key={service.Id}
                className="grid gap-4 rounded-lg border border-nos-neutral-200 p-4"
              >
                <span className="font-medium text-nos-neutral-900 font-title-h4">
                  {service.Package || t('Services.MainAddress.PackageFallback')}
                </span>
                <div className="grid gap-1">
                  <span className="text-nos-neutral-500 font-text-p2">
                    {t('Services.AddServices.Success.ServiceId')}
                  </span>
                  <span className="text-nos-neutral-900 font-text-p1">{service.Id}</span>
                </div>
                <div className="grid gap-1">
                  <span className="text-nos-neutral-500 font-text-p2">
                    {t('Services.AddServices.Success.Address')}
                  </span>
                  <span className="text-nos-neutral-900 font-text-p1">
                    {service.Address || t('Services.MainAddress.AddressFallback')}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </If>
      <div className="sticky bottom-0 mt-auto bg-nos-neutral-0">
        <Button
          skin="light"
          type="button"
          onClick={handleClick}
          disabled={loading}
          className="w-full tablet:w-fit"
          data-tid="button-success-done"
        >
          <If condition={loading} otherwise={t('Services.AddServices.Success.Button')}>
            <Loader width={24} height={24} />
          </If>
        </Button>
      </div>
    </div>
  );
}
